import { Column } from '@silevis/reactgrid';

export const lockTimeTabColumns: Column[] = [
  { columnId: 'checkbox', width: 50 },
  { columnId: 'firstName', width: 200 },
  { columnId: 'surname', width: 200 },
  { columnId: 'email', width: 250 },
  { columnId: 'lockDate', width: 200 },
];
